window.neemans = window.neemans || {};

window.neemans.NMSJSProductFAQ = class {
  constructor(element) {
    this.element = element;
    this.faqItems = element.querySelectorAll('[data-nms-js="faq-item"]');
    this.viewAllBtn = element.querySelector('[data-nms-js="faq-view-all"]');
    
    this.init();
  }

  init() {
    this.faqItems.forEach(item => {
      const question = item.querySelector('[data-nms-js="faq-question"]');
      if (question) {
        question.addEventListener('click', () => this.toggleFAQ(item));
        question.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.toggleFAQ(item);
          }
        });
      }
    });

    this.viewAllBtn?.addEventListener('click', () => {
      this.faqItems.forEach(item => item.classList.remove('nms-product-faq__item--hidden'));
      this.viewAllBtn.style.display = 'none';
    });
  }

  toggleFAQ(clickedItem) {
    const isOpen = clickedItem.classList.contains('nms-product-faq__item--open');
    
    this.faqItems.forEach(item => {
      if (item !== clickedItem && item.classList.contains('nms-product-faq__item--open')) {
        this.closeFAQ(item);
      }
    });

    isOpen ? this.closeFAQ(clickedItem) : this.openFAQ(clickedItem);
  }

  openFAQ(item) {
    const answer = item.querySelector('[data-nms-js="faq-answer"]');
    const button = item.querySelector('[data-nms-js="faq-question"]');
    
    if (!answer || !button) return;
    
    item.classList.add('nms-product-faq__item--open');
    button.setAttribute('aria-expanded', 'true');
    
    answer.style.maxHeight = '0px';
    answer.offsetHeight;
    answer.style.maxHeight = answer.scrollHeight + 'px';
    
    setTimeout(() => {
      if (item.classList.contains('nms-product-faq__item--open')) {
        answer.style.maxHeight = '';
      }
    }, 300);
  }

  closeFAQ(item) {
    const answer = item.querySelector('[data-nms-js="faq-answer"]');
    const button = item.querySelector('[data-nms-js="faq-question"]');
    
    if (!answer || !button) return;
    
    answer.style.maxHeight = answer.scrollHeight + 'px';
    answer.offsetHeight;
    answer.style.maxHeight = '0px';
    
    setTimeout(() => {
      item.classList.remove('nms-product-faq__item--open');
      button.setAttribute('aria-expanded', 'false');
      answer.style.maxHeight = '';
    }, 300);
  }
}

const initFAQs = () => {
  document.querySelectorAll('[data-nms-js="faq-section"]:not([data-faq-initialized])').forEach(section => {
    new window.neemans.NMSJSProductFAQ(section);
    section.dataset.faqInitialized = 'true';
  });
};

document.readyState === 'loading' 
  ? document.addEventListener('DOMContentLoaded', initFAQs)
  : initFAQs();
